import {createSlice} from '@reduxjs/toolkit';
import AdminApi from "../../../api/AdminApi";
import {showNotification} from "./notification";

type State = {
    data: Object,
    isLoading: boolean,
    error: Object | null,
    cellId: number | null
}

const initialState = {
    data: {},
    isLoading: false,
    error: null,
	cellId: null
}

const formatSectionName = (name: string) => {
    let result = name.slice(1);
    return result.replace(/\//g, " > ");
};

const sections = createSlice({
    name: 'sections',
    initialState,
    reducers: {
        fetchSectionsStart: (state: State) => {
            state.isLoading = true;
            state.error = null;
        },
        fetchSectionsSuccess: (state: State, action) => {
			const cellId = action.payload.cellId;
            if (action.payload && action.payload.data) {
            	const newData = action.payload.data.reduce((obj: Object, item: {brandId: string, sections:  Array<{id: string, name: string}>}) => {
					return {
						...obj,
						[item['brandId']]: item.sections.map(section => {
							return {
								value: `${item['brandId']}-${section.id}`,
								label: `${section.name.split('-')[0].trim()} - ${formatSectionName(section.id)}`
							}
						})
					}
				}, {});

                // Load additional sections in case that edit page has old sections that are not present in current dataset
                if (action.payload.additionalSections && action.payload.additionalSections.length) {
                    action.payload.additionalSections.forEach((additionalSection: string) => {
                        const explodedSection = additionalSection.split('-');
                        const brandId = explodedSection[0];
                        const additionalSectionName = explodedSection[1];

                        if (!newData[brandId].some((section: { value: string, label: string }) => section.value === additionalSection)) {
                            const brandName = newData[brandId][0] ? newData[brandId][0].label.split(' - ')[0] : null;

                            if (brandName) {
                                newData[brandId].push({ value: additionalSection, label: `${brandName} - ${formatSectionName(additionalSectionName)}` });
                            }
                        }
                    });
                }

            	state.data = {
					...state.data,
					[cellId]: newData
				}
            }
            state.isLoading = false;
            state.error = false;
            state.cellId = cellId;
        },
        fetchSectionsFailed: (state: State, action) => {
            state.isLoading = false;
            state.error = action.payload
        }
    }
});

// Actions
export const {
    fetchSectionsStart,
    fetchSectionsSuccess,
    fetchSectionsFailed
} = sections.actions;

export default sections.reducer;

// Thunk
export const fetchSections = (brands: string, type: string, search: string, additionalSections: Array<string>, cellId: number) => async (dispatch: Function) => {
    try {
        dispatch(fetchSectionsStart());
        const api = new AdminApi();
        const result = await api.getSections(brands, type, search);
        const payload = {
        	data: result,
            additionalSections,
			cellId
		}
        dispatch(fetchSectionsSuccess(payload));
    } catch (err: any) {
        dispatch(fetchSectionsFailed(err));
		dispatch(showNotification('error', err.message));
	}
}
